// import WorkspaceLayout from '@/Layouts/WorkspaceLayout';
import React, { useState, useRef, useEffect } from 'react';
import { router, usePage } from '@inertiajs/react';
import axios from 'axios';
import { isEqual } from 'lodash';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useCallback } from 'react';
  // Update your import statement
import { faLightbulb, faPaperPlane, faSearch, faCheckSquare, faComments, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ClipLoader } from 'react-spinners';


import ChatSidebar from '../../Components/Workspace/Chat/ChatSidebar';
import Synopsis from './Synopsis';
import CharacterSection from './CharacterSection';
import PlotItems from '../../Components/PlotItems';
import TodoList from '../../Components/TodoList';
import EvaluationDrawer from '../../Components/EvaluationDrawer';

import { ChatProvider } from '../../Contexts/ChatContext';
import { useChat } from '../../Contexts/ChatContext';
import ErrorBoundary from '../../Components/ErrorBoundary';
import  SceneEvaluationsModal  from './SceneEvaluationsModal';

import './Workspace.css';

const Workspace = () => {
  // References
  const chatSidebarRef = useRef(null);
  const lastSentWorkspaceData = useRef(null);
  const lastSavedWorkspaceData = useRef(null);
  const autoSaveTimerRef = useRef(null);
  const [isCustomDramaticQuestion, setIsCustomDramaticQuestion] = useState(false);
  const [isCustomTheme, setIsCustomTheme] = useState(false);
  const [isCustomPc, setIsCustomPc] = useState(false);
  const [isTodoDrawerOpen, setIsTodoDrawerOpen] = useState(false);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [autoSaveEnabled, setAutoSaveEnabled] = useState(true);
  const [autoSaveInterval, setAutoSaveInterval] = useState(60000);
  const [isChatModalOpen, setIsChatModalOpen] = useState(false);

  const { workspace, existingEvaluations = [] } = usePage().props;

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 992) {
        setIsChatModalOpen(false);
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleTodoDrawer = () => {
    setIsTodoDrawerOpen(!isTodoDrawerOpen);
  };
  
  const {
    uuid,
    movie_hash: movieHash,
    level,
    scene_number: sceneNumber,
    synopsis: initialSynopsis,
    characters: initialCharacters,
    plot_items: initialPlotItems,
    themes: initialThemes,
    selected_theme_name: initialSelectedThemeName = '',
    selected_theme_description: initialSelectedThemeDescription = '',
    pcs: initialPcs,
    selected_pc_name: initialSelectedPcName = '',
    selected_pc_description: initialSelectedPcDescription = '',
    chat_id: chatId,
    chatMessages: initialChatMessages,
    title: initialWorkspaceTitle,
    dramatic_question: initialDramaticQuestion = '',
    suggestions: initialSuggestions = {},
    dramatic_question_options: initialDramaticQuestionOptions = [],
    todo: initialTodo = {},
    ai_calls: initialAiCalls = 0,
    creative_direction: initialCreativeDirection = ''
  } = workspace || {};

  const [aiCalls, setAiCalls] = useState(initialAiCalls);
  const [creativeDirection, setCreativeDirection] = useState(initialCreativeDirection);

  const workspaceTitle = initialWorkspaceTitle || (() => {
    if (level === 'scene_text' && sceneNumber) {
      return `Scene ${sceneNumber} Beat Tweak`;
    } else if (level === 'scene_dialogue' && sceneNumber) {
      return `Workspace for Scene ${sceneNumber} Dialogue`;
    } else if (level === 'scene' && sceneNumber) {
      return `Workspace for Scene ${sceneNumber} Design`;
    } else if (sceneNumber) {
      return `Workspace for Scene ${sceneNumber}`;
    } else {
      const levelDisplay = level ? level.charAt(0).toUpperCase() + level.slice(1) : '';
      return `${levelDisplay} Workspace`;
    }
  })();

  const [todoItems, setTodoItems] = useState(() => {
    if (initialTodo?.items && Array.isArray(initialTodo.items)) {
      return initialTodo.items;
    }
    return [];
  });

  const [dramaticQuestion, setDramaticQuestion] = useState(initialDramaticQuestion);
  const [dramaticQuestionOptions, setDramaticQuestionOptions] = useState(initialDramaticQuestionOptions || []);
  const [synopsis, setSynopsis] = useState(initialSynopsis || '');
  const [characters, setCharacters] = useState(() => {
    if (Array.isArray(initialCharacters)) {
      return initialCharacters.map((char, i) => ({ id: char.id || `char-${i}-${Date.now()}`, ...char }));
    }
    return [];
  });

  const [themes, setThemes] = useState(initialThemes || []);
  const [selectedThemeName, setSelectedThemeName] = useState(initialSelectedThemeName);
  const [selectedThemeDescription, setSelectedThemeDescription] = useState(initialSelectedThemeDescription);
  
  const [pcs, setPcs] = useState(initialPcs || []);
  const [selectedPcName, setSelectedPcName] = useState(initialSelectedPcName);
  const [selectedPcDescription, setSelectedPcDescription] = useState(initialSelectedPcDescription);
  
  const [chatMessages, setChatMessages] = useState(() => {
    const normalize = (arr) => (arr || []).map((m, idx) => ({ content: m.content ?? m.message ?? m.text ?? '', isAi: typeof m.isAi === 'boolean' ? m.isAi : (m.role === 'assistant' || m.role === 'ai' || m.sender === 'assistant'), timestamp: m.timestamp ?? m.created_at ?? new Date().toISOString(), id: m.id ?? m.uuid ?? `chat-msg-${idx}` }));
    if (workspace.chat_history && Array.isArray(workspace.chat_history) && workspace.chat_history.length > 0) return normalize(workspace.chat_history);
    if (workspace.chatMessages && Array.isArray(workspace.chatMessages) && workspace.chatMessages.length > 0) return normalize(workspace.chatMessages);
    const title = workspaceTitle || workspace.title || 'your project';
    return [
      { content: `Welcome to the screenplay workspace for "${title}"! I'm here to help you develop and refine your story.`, isAi: true, timestamp: new Date().toISOString(), id: 'welcome-1' },
      { content: "Select a Beat to ask me about it, or type a question in the chat below.", isAi: true, timestamp: new Date().toISOString(), id: 'welcome-3' }
    ];
  });

  const [isSceneEvaluationsModalOpen, setIsSceneEvaluationsModalOpen] = useState(false);
  // const [sceneEvaluations, setSceneEvaluations] = useState(existingEvaluations || []);
const [sceneEvaluations, setSceneEvaluations] = useState([]);

  const [evaluations, setEvaluations] = useState(null);
  const [isEvaluatingWorkspace, setIsEvaluatingWorkspace] = useState(false);
  const [isAnalyzingDialogue, setIsAnalyzingDialogue] = useState(false);
  const [dialogueAnalysis, setDialogueAnalysis] = useState(null);
  const [isDialogueAnalysisModalOpen, setIsDialogueAnalysisModalOpen] = useState(false);
  const [plotItems, setPlotItems] = useState(initialPlotItems || []);
  const [selectedPlotItemId, setSelectedPlotItemId] = useState(null);

  const [suggestions, setSuggestions] = useState(() => {
    if (!initialSuggestions || Array.isArray(initialSuggestions)) return { plot_items: {}, characters: {}, theme: {} };
    return { plot_items: initialSuggestions.plot_items || {}, characters: initialSuggestions.characters || {}, theme: initialSuggestions.theme || {}, ...initialSuggestions };
  });

  const [activeTab, setActiveTab] = useState('plot');
  const [evaluation, setEvaluation] = useState(null);
  const [isEvaluationOpen, setIsEvaluationOpen] = useState(false);
  useEffect(() => {
    setSceneEvaluations(existingEvaluations || []);
  }, [existingEvaluations]);

  const getCurrentWorkspaceData = () => ({
    uuid, movieHash, level, synopsis, characters, themes, pcs,
    selected_theme_name: selectedThemeName, selected_theme_description: selectedThemeDescription,
    selected_pc_name: selectedPcName, selected_pc_description: selectedPcDescription,
    plotItems, dramaticQuestion, suggestions, sceneNumber, todo: { items: todoItems },
    creativeDirection,
    ai_calls: aiCalls
  });

  const checkForChanges = () => {
    const currentData = getCurrentWorkspaceData();
    const hasChanges = !isEqual(currentData, lastSavedWorkspaceData.current);
    setHasUnsavedChanges(hasChanges);
    return hasChanges;
  };

  useEffect(() => {
    lastSavedWorkspaceData.current = getCurrentWorkspaceData();
  }, []);

  useEffect(() => {
    if (autoSaveEnabled) {
      autoSaveTimerRef.current = setInterval(() => { if (checkForChanges()) saveWorkspace(); }, autoSaveInterval);
    } else if (autoSaveTimerRef.current) {
      clearInterval(autoSaveTimerRef.current);
    }
    return () => { if (autoSaveTimerRef.current) clearInterval(autoSaveTimerRef.current); };
  }, [autoSaveEnabled, autoSaveInterval, synopsis, characters, themes, plotItems, dramaticQuestion, suggestions, todoItems, creativeDirection]);

  const saveWorkspace = async () => {
    try {
      const workspaceData = getCurrentWorkspaceData();
      await router.put(`/workspace/${uuid}/update`, workspaceData, {
        preserveScroll: true,
        onSuccess: () => { lastSavedWorkspaceData.current = workspaceData; setHasUnsavedChanges(false); toast.success('Workspace saved successfully'); },
        onError: () => { toast.error('Failed to save workspace'); },
      });
    } catch (error) {
      console.error('Failed to save workspace:', error);
      toast.error('Failed to save workspace');
    }
  };

  const handleSendChat = async (message, isContextActive) => {
    const workspaceData = getCurrentWorkspaceData();
    const hasWorkspaceDataChanged = !isEqual(lastSentWorkspaceData.current, workspaceData);
    try {
      setChatMessages((prev) => [...prev, { content: message, isUser: true }]);
      const response = await axios.post(`/workspace/${uuid}/chat`, {
        message,
        ...(hasWorkspaceDataChanged && { workspaceData }),
        selectedPlotItemId: isContextActive ? selectedPlotItemId : null,
      });
      if (response.data.chat_response) {
        setChatMessages((prev) => [...prev, { content: response.data.chat_response, isUser: false }]);
      }
      // Update AI calls count from response
      if (response.data.ai_calls !== undefined) {
        updateAiCallsCount(response.data.ai_calls);
      }
      if (hasWorkspaceDataChanged) {
        lastSentWorkspaceData.current = workspaceData;
      }
    } catch (error) {
      console.error('Error sending chat:', error);
      toast.error('Error sending chat message');
    }
  };

  // const handleEvaluateWorkspace = async () => {
  //   try {
  //     setIsEvaluatingWorkspace(true);
  //     const workspaceData = getCurrentWorkspaceData();
  //     const response = await axios.post(`/workspace/${uuid}/evaluate-workspace`, {
  //       workspaceData
  //     });
  //     if (response.data.success) {
  //       setEvaluations(response.data.evaluation);
  //       setSuggestions(response.data.evaluation.suggestions || suggestions);
  //       toast.success('Workspace evaluated successfully');
  //       setIsEvaluationOpen(true);
  //     }
  //   } catch (error) {
  //     console.error('Failed to evaluate workspace:', error);
  //     toast.error('Failed to evaluate workspace');
  //   } finally {
  //     setIsEvaluatingWorkspace(false);
  //   }
  // };
 const handleEvaluateWorkspace = async () => {
    try {
      setIsEvaluatingWorkspace(true);
      const workspaceData = getCurrentWorkspaceData();
      
      const response = await axios.post(`/workspace/evaluate-workspace`, {
        workspaceData
      });
      
      if (response.data.current_evaluation && response.data.all_evaluations) {
        // Update evaluations with new data from backend
        setSceneEvaluations(response.data.all_evaluations);
        
        // Open the scene evaluations modal
        setIsSceneEvaluationsModalOpen(true);
        
        toast.success('Scene evaluated successfully');
      }
      // Update AI calls count from response
      if (response.data.ai_calls !== undefined) {
        updateAiCallsCount(response.data.ai_calls);
      }
    } catch (error) {
      console.error('Failed to evaluate workspace:', error);
      toast.error('Failed to evaluate workspace');
    } finally {
      setIsEvaluatingWorkspace(false);
    }
  };

  const handleShowPreviousEvaluations = () => {
    setIsSceneEvaluationsModalOpen(true);
  };

  const handleSuggestionsReceived = (events) => {
    console.log('Received suggestions:', events);
    setSuggestions((prev) => {
      const updated = { ...prev };
      if (events.suggestions) {
        Object.keys(events.suggestions).forEach(domain => {
          if (!updated[domain]) updated[domain] = {};
          Object.keys(events.suggestions[domain]).forEach(targetId => {
            if (!updated[domain][targetId]) updated[domain][targetId] = [];
            updated[domain][targetId] = [...updated[domain][targetId], ...events.suggestions[domain][targetId]];
          });
        });
      } else {
        events.forEach((event) => {
          const { targets, action, content } = event;
          targets.forEach((target) => {
            const domain = target.domain;
            const name = target.id.toLowerCase();
            if (!updated[domain]) updated[domain] = {};
            if (!updated[domain][name]) updated[domain][name] = [];
            updated[domain][name].push({ action, content });
          });
        });
      }
      setHasUnsavedChanges(true);
      return updated;
    });
  };

  const handleGetSuggestions = async () => {
    try {
      const response = await axios.post(`/workspace/${uuid}/get-suggestions`);
      if (response.data.success && response.data.suggestions) {
        handleSuggestionsReceived(response.data);
        toast.success('Suggestions received!');
      }
    } catch (error) {
      console.error('Failed to get suggestions:', error);
      toast.error('Failed to get suggestions');
    }
  };

  const handleDramaticQuestionChange = (value) => { setDramaticQuestion(value); setHasUnsavedChanges(true); };
  const handleDramaticQuestionSelect = (e) => { setDramaticQuestion(e.target.value); setHasUnsavedChanges(true); };
  const handleThemeChange = (e) => {
    const picked = themes.find((t) => t.name === e.target.value);
    if (picked) { setSelectedThemeName(picked.name); setSelectedThemeDescription(picked.description); }
    else { setSelectedThemeName(''); setSelectedThemeDescription(''); }
    setHasUnsavedChanges(true);
  };
  const handlePcChange = (e) => {
    const picked = pcs.find((p) => p.name === e.target.value);
    if (picked) { setSelectedPcName(picked.name); setSelectedPcDescription(picked.description); }
    else { setSelectedPcName(''); setSelectedPcDescription(''); }
    setHasUnsavedChanges(true);
  };
  const handleThemeNameChange = (value) => { setSelectedThemeName(value); setHasUnsavedChanges(true); };
  const handleThemeDescriptionChange = (value) => { setSelectedThemeDescription(value); setHasUnsavedChanges(true); };
  const handlePcNameChange = (value) => { setSelectedPcName(value); setHasUnsavedChanges(true); };
  const handlePcDescriptionChange = (value) => { setSelectedPcDescription(value); setHasUnsavedChanges(true); };
  const handleThemeSuggestionDismiss = (themeName, idx) => {
    setSuggestions((prev) => {
      const updated = { ...prev };
      if (!updated.theme) updated.theme = {};
      if (!updated.theme[themeName]) updated.theme[themeName] = [];
      updated.theme[themeName] = updated.theme[themeName].filter((_, i) => i !== idx);
      return updated;
    });
    setHasUnsavedChanges(true);
  };
  const handleAddCharacter = () => {
    const newCharacter = { id: `char-${Date.now()}`, name: `Character ${characters.length + 1}`, description: '', characterArc: '' };
    setCharacters(prev => [...prev, newCharacter]);
    setHasUnsavedChanges(true);
  };
  const handleCharacterUpdate = (updatedCharacter) => {
    setCharacters(prev => prev.map(char => char.id === updatedCharacter.id ? updatedCharacter : char));
    setHasUnsavedChanges(true);
  };
  const handleCharacterDelete = (charName) => {
    if (window.confirm('Are you sure you want to delete this character?')) {
      setCharacters(prev => prev.filter(char => char.name.toLowerCase() !== charName.toLowerCase()));
      setHasUnsavedChanges(true);
    }
  };
  const handlePlotItemUpdate = (id, content, newPlotItem = null) => {
    setPlotItems(prevItems => {
      const prevItemsArray = Array.isArray(prevItems) ? prevItems : Object.values(prevItems || {});
      if (newPlotItem) return [...prevItemsArray, newPlotItem];
      if (id) return prevItemsArray.map(item => item.id === id ? { ...item, content } : item);
      return prevItemsArray;
    });
    setHasUnsavedChanges(true);
  };

  const handlePlotItemReorder = (fromIndex, toIndex) => {
    const updated = [...plotItems];
    const [movedItem] = updated.splice(fromIndex, 1);
    updated.splice(toIndex, 0, movedItem);
    setPlotItems(updated);
    setHasUnsavedChanges(true);
  };

  const handlePlotItemDelete = (id) => {
    setPlotItems(prevItems => {
      const updatedItems = { ...prevItems };
      delete updatedItems[id];
      setHasUnsavedChanges(true);
      return updatedItems;
    });
  };

  const handleCreativeDirectionChange = (value) => {
    setCreativeDirection(value);
    setHasUnsavedChanges(true);
  };
  const handleReplacePlotItems = useCallback((newPlotItems) => { setPlotItems(newPlotItems); setHasUnsavedChanges(true); }, []);
  const handleSendQuestionToChat = (question) => { if (chatSidebarRef.current?.setChatInputValue) chatSidebarRef.current.setChatInputValue(question); };
  const handleAddTodoItem = (newTodoItem) => {
    const safeNewItem = { id: `todo-custom-${Date.now()}`, content: '', completed: false, type: 'custom', isEditing: true, ...newTodoItem };
    setTodoItems(prevItems => [...prevItems, safeNewItem]);
    setHasUnsavedChanges(true);
  };

  const updateAiCallsCount = (count) => {
    if (typeof count === 'number') {
      setAiCalls(count);
    }
  };

  return (
    <ErrorBoundary>
      <ChatProvider
        workspaceData={getCurrentWorkspaceData()}
        initialChatMessages={chatMessages}
        setChatMessages={setChatMessages}
        onSuggestionsReceived={handleSuggestionsReceived}
      >
        <div className="min-vh-100 bg-light">
          <div className="workspace-top-bar">
            <div className="container-fluid">
              <div className="row">
                <div className="col-12 col-lg-8">
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <h1 className="h3 mb-0">{workspaceTitle || 'Workspace for scene'}</h1>
                    </div>
                    <div className="d-flex align-items-center">
                      {hasUnsavedChanges && <span className="text-muted me-3"><small>Unsaved changes</small></span>}
                      <div className="form-check form-switch me-3">
                        <input className="form-check-input" type="checkbox" id="autoSaveToggle" checked={autoSaveEnabled} onChange={() => setAutoSaveEnabled(!autoSaveEnabled)} />
                        <label className="form-check-label" htmlFor="autoSaveToggle">Auto-save</label>
                      </div>
                      <button className="btn btn-primary" onClick={saveWorkspace} disabled={!hasUnsavedChanges}>Save Workspace</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="container-fluid">
            <div className="row">
              <div className="col-12 col-lg-8 main-content-area">
                <div className="card bg-white h-100">
                  <div className="card-header d-flex justify-content-between align-items-center">
                    <ul className="nav nav-tabs card-header-tabs">
                      <li className="nav-item"><button className={`nav-link ${activeTab === 'plot' ? 'active' : ''}`} onClick={() => setActiveTab('plot')}>Plot</button></li>
                      <li className="nav-item"><button className={`nav-link ${activeTab === 'theme' ? 'active' : ''}`} onClick={() => setActiveTab('theme')}>Theme</button></li>
                      <li className="nav-item"><button className={`nav-link ${activeTab === 'characters' ? 'active' : ''}`} onClick={() => setActiveTab('characters')}>Characters</button></li>
                      <li className="nav-item"><button className={`nav-link ${activeTab === 'creative_direction' ? 'active' : ''}`} onClick={() => setActiveTab('creative_direction')}>Creative Direction</button></li>
                    </ul>
                  </div>
                  <div className="card-body">
                    {activeTab === 'plot' && (
                      <>
                        <div className="mb-4">
                          <h5>Dramatic Question</h5>
                          <div className="d-flex align-items-start mb-2">
                            <div className="flex-grow-1">
                              {dramaticQuestionOptions && dramaticQuestionOptions.length > 0 ? (
                                <div className="input-group mb-2">
                                  <select className="form-select" value={dramaticQuestion} onChange={handleDramaticQuestionSelect}>
                                    <option value="">Select a dramatic question</option>
                                    {dramaticQuestionOptions.map((option, index) => <option key={index} value={option}>{option}</option>)}
                                  </select>
                                  <button className="btn btn-outline-secondary" onClick={() => setIsCustomDramaticQuestion(true)} title="Write custom dramatic question" type="button"><i className="fas fa-pencil-alt"></i> Custom</button>
                                </div>
                              ) : (
                                <textarea className="form-control" value={dramaticQuestion} onChange={(e) => handleDramaticQuestionChange(e.target.value)} placeholder={`Enter the dramatic question for this ${level}...`} rows={2} />
                              )}
                              {dramaticQuestionOptions && dramaticQuestionOptions.length > 0 && isCustomDramaticQuestion && (
                                <div className="mt-2">
                                  <textarea className="form-control" value={dramaticQuestion} onChange={(e) => handleDramaticQuestionChange(e.target.value)} placeholder="Customize your dramatic question..." rows={2} />
                                  <div className="d-flex justify-content-end mt-1">
                                    <button className="btn btn-sm btn-outline-secondary" onClick={() => setIsCustomDramaticQuestion(false)}>Use dropdown selection</button>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
<PlotItems
  plotItems={plotItems}
  level={level}
  onUpdate={handlePlotItemUpdate}
  onReorder={handlePlotItemReorder}
  onDelete={handlePlotItemDelete}
  onReplaceAllPlotItems={handleReplacePlotItems}
  suggestions={suggestions}
  setSuggestions={(newSuggestions) => { setSuggestions(newSuggestions); setHasUnsavedChanges(true); }}
  evaluations={evaluations}
  workspaceUuid={uuid}
  workspaceData={getCurrentWorkspaceData()}
  onSelectPlotItem={(plotItem) => setSelectedPlotItemId(plotItem.id)}
  onSendQuestionToChat={handleSendQuestionToChat}
  onAddTodoItem={handleAddTodoItem}
  onGetSuggestions={handleGetSuggestions}
  onEvaluateWorkspace={handleEvaluateWorkspace}
  onShowPreviousEvaluations={handleShowPreviousEvaluations}
  sceneEvaluations={sceneEvaluations}
  isEvaluatingWorkspace={isEvaluatingWorkspace}
  onUpdateAiCalls={updateAiCallsCount}
/>
                      </>
                    )}
                    {activeTab === 'theme' && (
                      <>
                        <h5>Edit Philosophical Conflict</h5>
                        <div className="mb-4">
                          <label className="form-label">Philosophical Conflict</label>
                          {isCustomPc ? (
                            <div className="p-3 border rounded">
                              <div className="mb-3"><label className="form-label">Custom Conflict Name</label><input type="text" className="form-control" value={selectedPcName || ""} onChange={(e) => handlePcNameChange(e.target.value)} /></div>
                              <div className="mb-3"><label className="form-label">Custom Conflict Description</label><textarea className="form-control" value={selectedPcDescription || ""} onChange={(e) => handlePcDescriptionChange(e.target.value)} rows="4" /></div>
                              <button className="btn btn-sm btn-outline-secondary" onClick={() => setIsCustomPc(false)}>Select from List</button>
                            </div>
                          ) : (
                            <div className="input-group">
                              <select className="form-select" value={selectedPcName || ""} onChange={handlePcChange}>
                                <option value="">Select a philosophical conflict</option>
                                {pcs.map((p, idx) => <option key={idx} value={p.name}>{p.name}</option>)}
                              </select>
                              <button className="btn btn-outline-secondary" onClick={() => setIsCustomPc(true)}>Custom</button>
                            </div>
                          )}
                        </div>
                        <h5>Edit Theme</h5>
                        <div className="mb-4">
                          <label className="form-label">Theme</label>
                          {isCustomTheme ? (
                            <div className="p-3 border rounded">
                              <div className="mb-3"><label className="form-label">Custom Theme Name</label><input type="text" className="form-control" value={selectedThemeName || ""} onChange={(e) => handleThemeNameChange(e.target.value)} /></div>
                              <div className="mb-3"><label className="form-label">Custom Theme Description</label><textarea className="form-control" value={selectedThemeDescription || ""} onChange={(e) => handleThemeDescriptionChange(e.target.value)} rows="4" /></div>
                              <button className="btn btn-sm btn-outline-secondary" onClick={() => setIsCustomTheme(false)}>Select from List</button>
                            </div>
                          ) : (
                            <div className="input-group">
                              <select className="form-select" value={selectedThemeName || ""} onChange={handleThemeChange}>
                                <option value="">Select a theme</option>
                                {themes.map((t, idx) => <option key={idx} value={t.name}>{t.name}</option>)}
                              </select>
                              <button className="btn btn-outline-secondary" onClick={() => setIsCustomTheme(true)}>Custom</button>
                            </div>
                          )}
                        </div>
                      </>
                    )}
                    {activeTab === 'characters' && (
                      <div className="characters-container">
                        {characters.length > 0 ? (
                          characters.map((character) => (
                            <CharacterSection
                              key={character.id}
                              character={character}
                              suggestions={suggestions?.characters?.[character.name.toLowerCase()] || []}
                              onUpdate={handleCharacterUpdate}
                              onDelete={handleCharacterDelete}
                            />
                          ))
                        ) : <p>No characters available</p>}
                        <button className="btn btn-sm btn-outline-primary mt-3" onClick={handleAddCharacter}>Add Character</button>
                      </div>
                    )}
                    {activeTab === 'creative_direction' && (
                      <div className="creative-direction-container">
                        <div className="alert alert-info">
                          <strong>This is optional</strong>, but providing creative direction can help the AI give more tailored and relevant feedback for this scene.
                        </div>

                        <div className="mb-3">
                          <label htmlFor="creativeDirection" className="form-label fw-bold">Creative Direction</label>
                          <textarea
                            id="creativeDirection"
                            className="form-control"
                            rows={8}
                            value={creativeDirection}
                            onChange={(e) => handleCreativeDirectionChange(e.target.value)}
                            placeholder="e.g., Focus on building tension through dialogue. The protagonist should seem vulnerable but determined. End with a power shift where the antagonist gains the upper hand. Keep the mood somber and emphasize the rain throughout the scene."
                          />
                          <small className="form-text text-muted">Provide high-level guidance for AI feedback on tone, character dynamics, pacing, story goals, or any specific creative constraints for this scene.</small>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="d-none d-lg-block col-lg-4">
                <div className="chat-sidebar-container h-100">
                  <ChatSidebar
                    ref={chatSidebarRef}
                    messages={chatMessages}
                    onSend={handleSendChat}
                    onEvaluate={handleEvaluateWorkspace}
                    selectedPlotItem={plotItems.find(item => item.id === selectedPlotItemId)}
                    isVisible={true}
                    aiCalls={aiCalls}
                  />
                </div>
              </div>
            </div>
          </div>

          <button 
            className="chat-toggle-btn d-lg-none"
            onClick={() => setIsChatModalOpen(true)}
          >
            <FontAwesomeIcon icon={faComments} />
          </button>

          {isChatModalOpen && (
            <div className="modal show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
              <div className="modal-dialog modal-dialog-scrollable modal-lg">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">AI Assistant</h5>
                    <button type="button" className="btn-close" onClick={() => setIsChatModalOpen(false)}></button>
                  </div>
                  <div className="modal-body p-0">
                    <ChatSidebar
                      messages={chatMessages}
                      onSend={handleSendChat}
                      onEvaluate={handleEvaluateWorkspace}
                      selectedPlotItem={plotItems.find(item => item.id === selectedPlotItemId)}
                      isVisible={true}
                      showTitle={false}
                      aiCalls={aiCalls}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
         <SceneEvaluationsModal
            isOpen={isSceneEvaluationsModalOpen}
            onClose={() => setIsSceneEvaluationsModalOpen(false)}
            evaluations={sceneEvaluations}
            workspaceTitle={workspaceTitle}
          />
        </div>
        <ToastContainer />
      </ChatProvider>
    </ErrorBoundary>
  );
};


export default Workspace;
